import React from "react";
import { FaCaretRight } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import blogsJson from "../../data/blogs.json";

const Section1 = () => {
  const currentDate = new Date().toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const { handle } = useParams();
  const blog = blogsJson.find((b) => b.handle === handle);

  return (
    <div className=" min-h-[300px] w-auto relative text-white bg-[#066fd9]">
      <div className="w-[80%] px-0 md:px-5 right-[50%] absolute bottom-4 flex flex-col gap-1"
      style={{transform: "translate(50%, 10px)"}}
      >
        <div className=" h-auto px-2 py-2 font-medium text-white uppercase bg-black lg:max-w-[50%] md:max-w-[50%] flex items-center gap-1 lg:w-fit w-auto ">
          <Link className="cursor-pointer" to="/">
            Home
          </Link>

          <span>
            <FaCaretRight style={{ color: "red", fontSize: "15px" }} />
          </span>
          <Link className="cursor-pointer" to="/blogs">
            Blogs
          </Link>
          <span>
            <FaCaretRight style={{ color: "red", fontSize: "15px" }} />
          </span>
          <Link className="cursor-pointer">current blog</Link>
        </div>
        <div className=" h-auto px-2 py-2 flex items-center gap-2 font-medium text-white uppercase bg-black max-w-[90%] lg:max-w-[80%] md:max-w-[80%] w-fit ">
          <span>
            <FaCaretRight style={{ color: "red", fontSize: "15px" }} />
          </span>
          <Link to={`/blog-details/${handle}`}>{blog.text}</Link>
        </div>
        <div className="max-w-[50%] bg-white opacity-50 inline-block text-black text-[10px] w-fit mt-2 px-2 rounded-sm ">
          {currentDate}
        </div>
      </div>
    </div>
  );
};

export default Section1;
